import DataService from '@/service/DataService'

const state = {
  status: {},
  fotoalben: []
}

const getters = {
  fotoalbumStatus: (state) => state.status,
  fotoalben: (state) => state.fotoalben
};

const actions = {
  // GET
  fetchFotoalbum( { commit }, id) {
    commit('GETFOTOALBUMREQUEST')

    return DataService.getFotoalbum(id)
      .then(res => {
        commit('GETFOTOALBUMSUCCESS', res.data)
      })
      .catch(err => {
        commit('GETFOTOALBUMFAILURE', err)
      })
  },
  fetchFotoalben( { commit }) {
    commit('GETFOTOALBENREQUEST')

    return DataService.getFotoalben()
      .then(res => {
        commit('GETFOTOALBENSUCCESS', res.data)
      })
      .catch(err => {
        commit('GETFOTOALBENFAILURE', err)
      })
  },
  getFotoalbumBild({commit}, data) {
    commit('GETFOTOALBUMBILDREQUEST')
    
    return DataService.getFotoalbumImage(data.fotoalbumId, data.filename)
      .then(res => {
        data.res = res.data
        commit('GETFOTOALBUMBILDSUCCESS', data)
      })
  },


  // POST
  createNeuesFotoalbum({ commit, dispatch }, fotoalbum) {
    commit('CREATENEUESFOTOALBUMREQUEST')

    return DataService.createFotoalbum(fotoalbum.titel)
      .then(res => {
        let getAlbum = true;

        for (let i = 0; i < fotoalbum.fotos.length; i++) {
          const data = {}
          data.fotoalbumId = res.data.id
          data.filename = fotoalbum.fotos[i].name
          data.foto = new FormData();
          data.foto.append('file', fotoalbum.fotos[i])

          dispatch('uploadFotoalbumBild', data)
            .then(() => {
              if(getAlbum) {
                getAlbum = false

                dispatch('fetchFotoalbum', res.data.id)
              }
            })
        }

        commit('CREATENEUESFOTOALBUMSUCCESS')
        // dispatch('fetchFotoalbum', res.data.id)
      })
      .catch(err => {
        commit('CREATENEUESFOTOALBUMFAILURE', err.response)
      })
  },
  uploadFotoalbumBild({commit}, data) {
    commit('UPLOADFOTOALBUMBILDREQUEST')

    return DataService.uploadFotoalbumImage(data.fotoalbumId, data.foto, data.filename)
      .then(() => {
        commit('UPLOADFOTOALBUMBILDSUCCESS')
      })
      .catch(err => {
        if(err.response.data) {
          commit('UPLOADFOTOALBUMBILDFAILURE', err.response.data)
        } else {
          commit('UPLOADFOTOALBUMBILDFAILURE', err)
        }
      })
  },

  // DELETE
  removeFotoalbum({ commit }, fotoalbumId) {
    commit('DELETEFOTOALBUMREQUEST')

    return DataService.deleteFotoalbum(fotoalbumId)
      .then(() => {
        commit('DELETEFOTOALBUMSUCCESS', fotoalbumId)
      })
      .catch(err => {
        commit('DELETEFOTOALBUMFAILURE', err)
      })
  }
};

const mutations = {
  CREATENEUESFOTOALBUMREQUEST: (state) => {state.status = { creatingNeuesFotoalbum: true }},
  CREATENEUESFOTOALBUMSUCCESS: (state) => {state.status = { fotoalbumCreated: true}},
  CREATENEUESFOTOALBUMFAILURE: (state, err) => {state.status = {errMsg: err}},
  UPLOADFOTOALBUMBILDREQUEST: (state) => {state.status = {uploadingFotoalbumBild: true}},
  UPLOADFOTOALBUMBILDSUCCESS: (state) => {
    state.status = {}
    
    // let index = state.fotoalben.findIndex(x => x.id == res.fotoalbumId)
    // if(!state.fotoalben[index].fotos) state.fotoalben[index].fotos = []

    // state.fotoalben[index].fotos.push(res)
  },
  UPLOADFOTOALBUMBILDFAILURE: (state, err) => {state.status = {errMsg: err}},
  GETFOTOALBUMREQUEST: (state) => {state.status ={getFotoalbum: true}},
  GETFOTOALBUMSUCCESS: (state, res) => {
    state.status = {}
    state.fotoalben.push(res)
  },
  GETFOTOALBUMFAILURE: (state, err) => {state.status = {errMsg: err}},
  GETFOTOALBENREQUEST: (state) => {state.status ={getFotoalbum: true}},
  GETFOTOALBENSUCCESS: (state, res) => {
    state.status = {}
    state.fotoalben = res
  },
  GETFOTOALBENFAILURE: (state, err) => {state.status = {errMsg: err}},
  GETFOTOALBUMBILDREQUEST: (state) => {state.status ={getFotoalbumBild: true}},
  GETFOTOALBUMBILDSUCCESS: (state, data) => {
    state.status = {}

    let fotoalbumIndex = state.fotoalben.findIndex(x => x.id == data.fotoalbumId)
    let fileIndex = state.fotoalben[fotoalbumIndex].fotos.findIndex(x => x.titel == data.filename)

    state.fotoalben[fotoalbumIndex].fotos[fileIndex].contentType = data.res.contentType
    state.fotoalben[fotoalbumIndex].fotos[fileIndex].image = data.res.image
  },
  GETFOTOALBUMBILDFAILURE: (state, err) => {state.status ={errMsg: err}},
  DELETEFOTOALBUMREQUEST: (state) => {state.status ={deleteFotoalbum: true}},
  DELETEFOTOALBUMSUCCESS: (state, fotoalbumId) => {
    let index = state.fotoalben.findIndex(x => x.id == fotoalbumId)
    state.fotoalben.splice(index, 1)
    state.status = {}
  },
  DELETEFOTOALBUMFAILURE: (state, err) => {state.status = {errMsg: err}}
};

export default {
  state,
  getters,
  actions,
  mutations
}